import Select, { ValueContainerProps, components } from 'react-select';

const AdminNonScriptRangeFilters = (props: any) => {
  const ValueContainer = ({ children, ...props }: ValueContainerProps<any>) => {
    let [values, input] = children as any;

    if (Array.isArray(values)) {
      const plural = values.length === 1 ? '' : 's';
      values = `${values.length} item${plural} selected`;
    }

    return (
      <components.ValueContainer {...props}>
        {values}
        {input}
      </components.ValueContainer>
    );
  };

  return (
    <>
      <small className="ml-5">Areas of Care</small>
      <Select
        classNames={{
          control: (state) =>
            `${
              state.isFocused
                ? 'border-grey-400 border text-sm'
                : 'border-grey-400 border text-sm'
            } w-60 cursor-pointer ml-2`,
        }}
        value={
          localStorage.getItem('productCondition')
            ? JSON.parse(localStorage.getItem('productCondition') as string)
            : props.sortByCondition
        }
        options={props.productCondition?.sort(
          (a: { label: string }, b: { label: string }) =>
            a.label.localeCompare(b.label),
        )}
        onChange={(selected) => {
          props.setSortByCondition([...selected]);
          localStorage.setItem('productCondition', JSON.stringify(selected));
        }}
        isSearchable
        hideSelectedOptions={false}
        isMulti
        isClearable
        components={{ ValueContainer }}
      />
    </>
  );
};

export default AdminNonScriptRangeFilters;
